import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_TRACKING_MAP_DATA } from '../actions';
import { flattenBookingsToJobs } from '../api/DataHandlers';

const loadTrackingMapEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_TRACKING_MAP_DATA).mergeMap(action =>
        Observable.from(api.fetchTrackingDataForMap(action.payload))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(response))
            .catch(() =>
                Observable.of(
                    actions.trackingDataForMapFailure(
                        'Problem loading tracking map data',
                    ),
                ),
            ),
    );

const toAction = response => {
    if (response) {
        return actions.trackingDataForMapSuccess(
            flattenBookingsToJobs(response.data),
        );
    }
    return actions.trackingDataForMapFailure(
        'Problem loading tracking for map data',
    );
};

export default loadTrackingMapEpic;
